import React from "react";
import { AlertTriangle } from "lucide-react";
import { isUrgent } from "./helpers";

/**
 * Badge visibile SOLO se il job è flaggato come urgente lato admin.
 * Ritorna null altrimenti (nessun impatto UI per job normali).
 */
export function UrgencyBadge({ job, size = "sm", context = "" }) {
  if (!isUrgent(job)) return null;
  const isLg = size === "lg";
  const suffix = context ? `${context}-${job.tracking_number || "job"}` : (job.tracking_number || "job");
  return (
    <span
      className={`inline-flex items-center gap-1 bg-red-600 text-white font-bold uppercase rounded-sm animate-pulse ${isLg ? "px-2.5 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]"}`}
      data-testid={`urgent-badge-${suffix}`}
    >
      <AlertTriangle size={isLg ? 14 : 11} strokeWidth={2.5} /> URGENTE
    </span>
  );
}
